import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { NgProgress } from '@ngx-progressbar/core';
import { Injectable } from '@angular/core';

const _disabledProgress = 'DISABLED';

@Injectable()
export class Progress implements HttpInterceptor {
  constructor(private progress: NgProgress) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.get('disabledProgress') !== _disabledProgress) {
      this.progress.start();
    }
    const headers = req.headers.delete('disabledProgress');
    return next.handle(req.clone({ headers })).do(
      res => {
        if (res.type !== 0) {
          this.progress.complete();
        }
      },
      () => this.progress.complete()
    );
  }
}

export const ProgressInterceptor = { provide: HTTP_INTERCEPTORS, useClass: Progress, multi: true };

export const disabledProgress = { headers: { disabledProgress: _disabledProgress } };
